module.exports = __webpack_public_path__ + "static/media/layer7M.a49db0ec.png";